import {FinancingRateMatrixCell} from '@dms/api/vehicle';

import {FinancingCellCoordinates} from '../types/FinancingCellCoordinates';
import {getFinancingCellKey} from './getFinancingCellKey';

export function findFinancingCell(
  cells: FinancingRateMatrixCell[],
  coordinates: FinancingCellCoordinates
) {
  const cellKey = getFinancingCellKey(coordinates);

  return cells.find((cell) => getFinancingCellKey(cell) === cellKey) ?? null;
}
